
/*
 * PAWS & PEARLS — SECRET SKY
 * DAYLIGHT BIRD AUDIO V1
 *
 * Independent sound layer.
 * Does not alter the Chocolate Waltz,
 * Open Sky wind, House Sound controls,
 * balloon animations or visual birds.
 */

(function () {
  'use strict';

  var stage = document.getElementById(
    'pp-muse-balloon-stage'
  );

  if (
    !stage ||
    stage.dataset.ppDaylightBirdAudioV1 === '1'
  ) return;

  var balloon = stage.querySelector(
    'button.pp-balloon'
  );

  if (!balloon) return;

  stage.dataset.ppDaylightBirdAudioV1 = '1';

  var AUDIO_URL =
    'https://cdn.shopify.com/s/files/1/0784/0831/9166/files/Paws_Pearls_Secret_Sky_Daylight_Birds_v1.mp3?v=1793171011';

  // Initial listening volume.
  // Change only after testing.
  var PEAK_VOLUME = 0.30;

  // Seconds after the balloon click.
  var PASSAGES = [
    [20.5, 31.5],
    [39.0, 49.0]
  ];

  var FADE_SECONDS = 2;
  var STOP_AT_SECONDS = 52;

  var audio = null;
  var running = false;
  var disposed = false;
  var startedAt = 0;
  var ticker = 0;

  function houseAllowsSound() {
    var house = window.ppHouseSound;

    if (
      !house ||
      typeof house.isEnabled !== 'function'
    ) return false;

    try {
      return house.isEnabled() === true;
    } catch (_error) {
      return false;
    }
  }

  function smooth(x) {
    x = Math.max(0, Math.min(1, x));
    return x * x * (3 - 2 * x);
  }

  function passageVolume(t, start, end) {
    if (t <= start || t >= end) return 0;

    var fadeIn = smooth(
      (t - start) / FADE_SECONDS
    );

    var fadeOut = smooth(
      (end - t) / FADE_SECONDS
    );

    return Math.min(fadeIn, fadeOut);
  }

  function stop() {
    running = false;

    if (ticker) {
      clearInterval(ticker);
      ticker = 0;
    }

    if (audio) {
      try {
        audio.pause();
        audio.currentTime = 0;
        audio.volume = 0;
      } catch (_error) {
        // Other House sounds are unaffected.
      }
    }
  }

  function update() {
    if (!running || disposed) return;

    if (!houseAllowsSound()) {
      stop();
      return;
    }

    var t = (
      performance.now() - startedAt
    ) / 1000;

    if (t >= STOP_AT_SECONDS) {
      stop();
      return;
    }

    var level = 0;

    for (var i = 0; i < PASSAGES.length; i++) {
      level = Math.max(
        level,
        passageVolume(
          t,
          PASSAGES[i][0],
          PASSAGES[i][1]
        )
      );
    }

    if (audio) {
      audio.volume = Math.min(
        1,
        level * PEAK_VOLUME
      );
    }
  }

  function onBalloonClick() {
    if (
      disposed ||
      running ||
      !houseAllowsSound()
    ) return;

    if (
      window.matchMedia &&
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
    ) return;

    // Start from the visitor's actual click.
    // Safari therefore receives a user gesture.
    //
    // The short recording loops silently.
    // Only the scheduled passages become audible.
    // No delayed play() calls are required.

    if (!audio) {
      audio = new Audio(AUDIO_URL);
      audio.preload = 'auto';
      audio.loop = true;
    }

    try {
      audio.pause();
      audio.currentTime = 0;
      audio.volume = 0.001;

      startedAt = performance.now();
      running = true;

      var attempt = audio.play();

      if (
        attempt &&
        typeof attempt.catch === 'function'
      ) {
        attempt.catch(function (error) {
          if (!running) return;

          console.warn(
            '[P&P Daylight Birds] Playback unavailable:',
            error && error.name
          );

          stop();
        });
      }

      ticker = setInterval(update, 100);

    } catch (error) {
      console.warn(
        '[P&P Daylight Birds] Playback failed:',
        error && error.name
      );

      stop();
    }
  }

  function onHouseSoundChange() {
    if (!houseAllowsSound()) stop();
  }

  function onVisibilityChange() {
    if (document.hidden) stop();
  }

  function onSectionUnload(event) {
    if (
      !event ||
      !event.target ||
      !event.target.contains(stage)
    ) return;

    disposed = true;
    stop();

    balloon.removeEventListener(
      'click', onBalloonClick
    );

    document.removeEventListener(
      'pp:house-sound-change',
      onHouseSoundChange
    );

    window.removeEventListener(
      'pp:house-sound-change',
      onHouseSoundChange
    );

    document.removeEventListener(
      'visibilitychange',
      onVisibilityChange
    );

    document.removeEventListener(
      'shopify:section:unload',
      onSectionUnload
    );

    window.removeEventListener(
      'pagehide', stop
    );
  }

  balloon.addEventListener(
    'click', onBalloonClick
  );

  document.addEventListener(
    'pp:house-sound-change',
    onHouseSoundChange
  );

  window.addEventListener(
    'pp:house-sound-change',
    onHouseSoundChange
  );

  document.addEventListener(
    'visibilitychange',
    onVisibilityChange
  );

  document.addEventListener(
    'shopify:section:unload',
    onSectionUnload
  );

  window.addEventListener(
    'pagehide', stop
  );

})();
